import React from 'react';
import {
  Route,
  Redirect,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { setEmployee } from '@redux/actions/PartnerStoreActions';
import { bindActionCreators } from 'redux';
import { GetPartnerInformation } from '../../utils/Partner';
import { setAuthenticated } from '../../redux/actions/auth/AuthActions';

function LoggedInRoutePartner({ children, $actions, ...rest }) {
  const { dispatch, isAuthenticated } = rest;
  const [getUser, { data, error }] = useLazyQuery(GetPartnerInformation);
  React.useEffect(() => {
    if (isAuthenticated) {
      getUser({
        errorPolicy: 'all',
      });
    }
  }, [isAuthenticated]);
  React.useEffect(() => {
    if (error) dispatch(setAuthenticated(false));
  }, [error]);

  React.useEffect(() => {
    if (data) {
      $actions.setEmployee(data.MeTradeInUser);
    }
  }, [data]);



  return (
    <Route
      {...rest}
      render={
        ({ location }) => (isAuthenticated && localStorage.storeCollect ? (
          <>
            {children}
          </>
        ) : (<Redirect to={{ pathname: '/partners/login', state: { from: location } }} />))
}
    />
  );
}
function mapStateToProps(state) {
  const { AuthReducer } = state;
  const { isAuthenticated, user } = AuthReducer;
  return {
    isAuthenticated,
    user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  $actions: bindActionCreators({ setEmployee }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoggedInRoutePartner);
